var lodash = require('lodash');
var Vue = require('vue');

var _ = lodash;
window._ = _;
window.lodash = lodash;

window.mountVueComponent = (id, component) => {
    var root = document.getElementById(id);
    if (root) {
        var data = null;
        var config = null;

        try {
            var content = root.textContent;
            content = JSON.parse(content);
            data = content.data || null;
            config = content.config || null;

        } catch (e) {
            console.info(`Problem parsing data and config for component ${id}`);
        }

        new Vue({
            el: root,
            render: h => h(component, {
                props: { initialData: data, config }
            }),
        })
    }
}

window.dispatchEvent(new CustomEvent('vue-init'));




// WEBPACK FOOTER //
// ./resources/assets/site/js/vue-init.js